import ContentPagesAPI from '@/api/ContentPagesAPI';
import { BASE_API_URL } from '@/constants/common';
import { IMAGE_MIME_TYPES } from '@/constants/files';

/** Accept header value: product images + webp (matches BlogMediaUploadRequest). */
export const BLOG_IMAGE_ACCEPT = `${IMAGE_MIME_TYPES},image/webp`;

/**
 * Full URL for <img src> when API returns a path like /storage/...
 */
export function resolveBlogMediaDisplayUrl(url: string): string {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('data:')) return url;
  const base = BASE_API_URL.replace(/\/$/, '');
  const path = url.startsWith('/') ? url : `/${url}`;
  return base ? `${base}${path}` : path;
}

export async function uploadBlogImageFile(file: File): Promise<string> {
  const { data } = await ContentPagesAPI.uploadBlogMedia(file);
  const url = data?.data?.url;
  if (typeof url !== 'string' || !url.trim()) {
    throw new Error('Invalid upload response: missing url');
  }
  return url.trim();
}
